import Couple from "../../utils/images/slide-footer.jpg";
import styled from "styled-components";
import React from "react";
import { HeartFilled } from "@ant-design/icons";
import { HeartStyle } from "../data/data";

const Layout = styled.div`
  font-family: "Oswald", sans-serif;
  .name {
    color: #fff;
    font-size: 40px;
  }
`;
function GalFooter() {
  return (
    <>
      <Layout>
        <div style={styles.bgParallax}>
          <p>
            <HeartStyle>
              <span className="white-line"></span>
              <HeartFilled style={{ fontSize: 19, zIndex: 20, color: "red" }} />
              <HeartFilled
                style={{
                  fontSize: 19,
                  marginLeft: -5,
                  color: "white",
                }}
              />
              <span className="white-line"></span>
            </HeartStyle>
          </p>
          <p>
            <span className="name">Victor & Ufedo</span>
          </p>
        </div>
      </Layout>
    </>
  );
}

const styles = {
  bgParallax: {
    background: `url(${Couple})`,
    height: 400,
    width: "100%",
    backgroundSize: "cover",
    backgroundPosition: "center",
    // backgroundAttachment: "fixed",
    display: "flex",
    flexDirection: "column",
    justifyContent: "Center",
    alignItems: "center",
  },
};

export default GalFooter;
